import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { useQueryAdminCard } from '@webapp/modules/spending-cards/features/get-card-admin/models/useQueryAdminCard'
import messages from './messages'

export const useGetCardAdminPresenter = ({
  externalId,
  enabled = true,
}: {
  externalId: string
  enabled?: boolean
}) => {
  const intl = useProcurifyIntl()

  const { adminCard, isFetching, refetch } = useQueryAdminCard({
    externalId,
    enabled,
    onError: () => {
      toast.error({
        title: intl.formatMessage(messages.errorFetchingCardToastTitle),
      })
    },
  })

  return {
    data: {
      adminCard,
    },
    commands: {
      refetch,
    },
    states: {
      isFetching,
    },
  }
}
